import React, { useState, useEffect, useRef } from "react";
import RecipeCard from "./RecipeCard";
import { RECIPES } from "../../data/recipes";

const Recipes = () => {
  const [visibleRecipes, setVisibleRecipes] = useState(12);
  const [isLoading, setIsLoading] = useState(false);
  const observerRef = useRef(null);
  const loadMoreRef = useRef(null);

  useEffect(() => {
    // Set up intersection observer for lazy loading
    console.log("Recipes", RECIPES);
    const observer = new IntersectionObserver(
      (entries) => {
        const target = entries[0];
        if (
          target.isIntersecting &&
          !isLoading &&
          visibleRecipes < RECIPES.length
        ) {
          setIsLoading(true);
          // Simulate a small delay for better UX
          setTimeout(() => {
            setVisibleRecipes((prev) => Math.min(prev + 12, RECIPES.length));
            setIsLoading(false);
          }, 300);
        }
      },
      {
        rootMargin: "100px", // Start loading when within 100px of the element
        threshold: 0.1,
      }
    );

    if (loadMoreRef.current) {
      observer.observe(loadMoreRef.current);
    }

    observerRef.current = observer;

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, [visibleRecipes, isLoading]);

  return (
    <div className="tw-mt-8">
      <div className="recipeCards tw-bg-white dark:tw-bg-black tw-shadow-sm tw-rounded-3xl tw-px-6 sm:tw-px-12 tw-py-8 sm:tw-py-12">
        <div className="tw-grid tw-grid-cols-2 md:tw-grid-cols-4 tw-gap-6">
          {RECIPES.slice(0, visibleRecipes).map((recipe, idx) => (
            <div key={idx}>
              <RecipeCard
                recipe={recipe}
                lazyLoad={idx >= 12} // Lazy load images after first 12
              />
            </div>
          ))}
        </div>

        {/* Loading indicator */}
        {visibleRecipes < RECIPES.length && (
          <div
            ref={loadMoreRef}
            className="tw-flex tw-justify-center tw-mt-8 tw-py-4"
          >
            {isLoading ? (
              <div className="tw-flex tw-items-center tw-gap-2 tw-text-gray-600 dark:tw-text-gray-400">
                <div className="tw-loader tw-border-2 tw-border-gray-300 tw-border-t-blue-600 tw-rounded-full tw-w-5 tw-h-5 tw-animate-spin"></div>
                <span>Loading more recipes...</span>
              </div>
            ) : (
              <div className="tw-text-gray-500 dark:tw-text-gray-400 tw-text-sm">
                Scroll to load more
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Recipes;
